import type { RosterFilterUrlParams, RosterFilterUrlParamType } from '../types';

// NOTE: Changing these param values will break pre-existing deep links!
export const FILTER_PARAMS: Record<
  keyof RosterFilterUrlParams,
  RosterFilterUrlParamType
> = {
  labelIds: 'labels',
  isCrossover: 'crossover',
  isOnRoster: 'on_roster',
  searchText: 'search',
};

export function parseFiltersFromUrlParams(
  urlParams: URLSearchParams,
): RosterFilterUrlParams {
  const labelIdsValue = urlParams.get(FILTER_PARAMS.labelIds);
  const isCrossoverValue = urlParams.get(FILTER_PARAMS.isCrossover);
  const isOnRosterValue = urlParams.get(FILTER_PARAMS.isOnRoster);
  const searchTextValue = urlParams.get(FILTER_PARAMS.searchText) || undefined;

  return {
    labelIds: labelIdsValue?.split(',').map(Number) ?? [],
    isCrossover: isCrossoverValue === 'true',
    isOnRoster:
      isOnRosterValue === null || !['true', 'false'].includes(isOnRosterValue)
        ? undefined
        : JSON.parse(isOnRosterValue),
    searchText: searchTextValue,
  };
}

/**
 * Function takes a set of RosterFilters and returns URLSearchParams
 */
export function formatFiltersToUrlParams(
  filters: Partial<RosterFilterUrlParams>,
): URLSearchParams {
  const newUrlParams = new URLSearchParams();

  if (filters.labelIds?.length) {
    newUrlParams.set(FILTER_PARAMS.labelIds, filters.labelIds.join(','));
  }

  if (filters.isCrossover) {
    newUrlParams.set(FILTER_PARAMS.isCrossover, `${filters.isCrossover}`);
  }

  if (filters.isOnRoster !== undefined) {
    newUrlParams.set(FILTER_PARAMS.isOnRoster, `${filters.isOnRoster}`);
  }

  if (filters.searchText) {
    newUrlParams.set(FILTER_PARAMS.searchText, filters.searchText);
  }

  return newUrlParams;
}
